// Patches Bootstrap's Tooltip to be null-safe after dispose().
//
// Bootstrap's BaseComponent#dispose() nulls out every own property of a
// component instance (including `_activeTrigger` and `_element`). If a
// `transitionend` callback that was already scheduled before dispose() fires
// afterwards (e.g. during a fast Turbo re-render), methods crash:
//
//   Object.values(this._activeTrigger).includes(true)
//   TypeError: Cannot convert undefined or null to object
//
//   this._element.removeAttribute('aria-describedby')
//   TypeError: Cannot read properties of null (reading 'removeAttribute')
//
// See: TSHMANAGERWEB-GR, TSHMANAGERWEB-HG (Sentry). Known Bootstrap 5.3.x issue;
// we patch once at boot rather than touching the vendored library code.
import { Tooltip } from "bootstrap"

const originalIsWithActiveTrigger = Tooltip.prototype._isWithActiveTrigger

Tooltip.prototype._isWithActiveTrigger = function patchedIsWithActiveTrigger() {
  if (!this._activeTrigger || !this._element) {
    return false
  }

  return originalIsWithActiveTrigger.call(this)
}

// TSHMANAGERWEB-HG: transitionend after dispose() still runs _completeHide
const originalCompleteHide = Tooltip.prototype._completeHide
if (typeof originalCompleteHide === "function") {
  Tooltip.prototype._completeHide = function patchedCompleteHide(...args) {
    if (!this._element) {
      return
    }
    return originalCompleteHide.apply(this, args)
  }
}
